import * as actionTypes from 'constants/ActionTypes';

export function addNotification(notification) {
    return {
        type: actionTypes.ADD_NOTIFICATION,
        notification,
    };
}

export function deleteNotification(notification) {
    return {
        type: actionTypes.DELETE_NOTIFICATION,
        notification,
    };
}



// WEBPACK FOOTER //
// ./app/actions/notifications/notifications.js